import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { PercentageIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/configuration-management/commissions')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="configurationManagement.commissions.crumb" icon={PercentageIcon} />,
      title: <CrumbTitle id="configurationManagement.commissions.page.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
